import * as React from 'react';

export function IconStar(): JSX.Element {
    return (
        <svg width="1em"
             height="1em"
             viewBox="0 0 18 17"
             shapeRendering="auto">
            <polygon fill="currentColor"
                     fillRule="evenodd"
                     points="282 391.481 275.528 390.929 273 385 270.472 390.929 264 391.481 268.909 395.711 267.438 402 273 398.664 278.562 402 277.091 395.711"
                     transform="translate(-264 -385)"/>
        </svg>
    );
}
